export default __webpack_public_path__ + "static/Flag_of_Kenya.svg-f7f9790c71681c49bf9300b8057e6276.png";